import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";

const LOCATIONS = [
  "Manchester", "Liverpool", "London", "Birmingham", "Leeds", "Newcastle",
  "Sheffield", "Stoke-on-Trent", "Chester", "Stockport", "Brighton", "Essex",
  "Oxford", "Bath", "Slough", "Southampton", "Bristol",
];

const slugFor = (name) => name.toLowerCase().replace(/\s/g, "-");

export default function InteriorsLocations() {
  return (
    <section style={{
      backgroundColor: "#f4f2f0",
      paddingTop: "clamp(56px, 6vw, 88px)",
      paddingBottom: "clamp(56px, 6vw, 88px)",
      paddingLeft: "clamp(20px, 5vw, 80px)",
      paddingRight: "clamp(20px, 5vw, 80px)",
    }}>
      <div style={{ maxWidth: 1100, margin: "0 auto", textAlign: "center" }}>
        <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", color: "#888", marginBottom: 14, marginTop: 0 }}>
          Where we cover
        </p>
        <h2 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: "clamp(26px, 3vw, 38px)", letterSpacing: "-0.02em", lineHeight: 1.2, color: "#1A1A1A", marginTop: 0, marginBottom: 16 }}>
          Airbnb interior design and furnishing across the UK
        </h2>
        <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 16, color: "#555", lineHeight: 1.65, maxWidth: 680, margin: "0 auto 40px" }}>
          Our furniture partner delivers and installs nationwide, so wherever your short-let property is based, we can have it fully styled and guest-ready within 7 days. We manage properties directly in the following areas:
        </p>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 12 }} className="interiors-locations-grid">
          {LOCATIONS.map((name) => (
            <Link
              key={name}
              to={`/management/${slugFor(name)}/`}
              style={{
                display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
                background: "#fff", border: "1px solid #E5E2DE", borderRadius: 10,
                padding: "13px 14px", textDecoration: "none",
                fontFamily: "'DM Sans', sans-serif", fontSize: 14, fontWeight: 500, color: "#1A1A1A",
                transition: "border-color 0.2s, transform 0.2s",
              }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = "#1A1A1A"; e.currentTarget.style.transform = "translateY(-2px)"; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = "#E5E2DE"; e.currentTarget.style.transform = "translateY(0)"; }}
            >
              <MapPin size={13} color="#888" />
              {name}
            </Link>
          ))}
        </div>

        <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#888", lineHeight: 1.7, maxWidth: 680, margin: "32px auto 0" }}>
          Don't see your city listed? Furniture delivery and installation is available UK-wide — <Link to="/support" style={{ color: "#1A1A1A", fontWeight: 600, textDecoration: "none" }}>get in touch</Link> and we'll confirm coverage for your area.
        </p>
      </div>

      <style>{`
        @media (max-width: 900px) { .interiors-locations-grid { grid-template-columns: repeat(3, 1fr) !important; } }
        @media (max-width: 600px) { .interiors-locations-grid { grid-template-columns: repeat(2, 1fr) !important; } }
      `}</style>
    </section>
  );
}